__turbopack_context__.v({
  "className": "space_grotesk_fe09f16-module__GL8ZWW__className",
  "variable": "space_grotesk_fe09f16-module__GL8ZWW__variable",
});
